import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import ShopAddImageRequest from '../../../RunPay/Admin/IServices/Models/Shop/ShopAddImageRequest';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';

export default class ShopService {
	webApiService: WebApiService;
	AddImageEvent = new Events<WsResponseModel<String>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('ShopService', 'AddImage', (res: WsResponseModel<String>) => {
			self.AddImageEvent.trigger(res);
		});
	}
	AddImage(request: ShopAddImageRequest = null) { 	
        this.webApiService.send('ShopService', 'AddImage' , request);
    }
	 // async methods
	async addImageAsync(request: ShopAddImageRequest = null): Promise<String> {
		return EventToAsyncDecorator.getInstance().bind(this.AddImage.bind(this), this.AddImageEvent)(request);
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/ShopService.ts